/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{Z as s,O as o}from"../../../../chunks/vec4f64.js";const c=1,r=1.2,t=s,a=o;export{r as SUSPEND_RESUME_EXTENT_OPTIMISM,t as TRANSPARENT_UNIT,a as WHITE_UNIT,c as defaultIconElevationOffset};
